import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GlobalValidationService } from 'src/app/global-validation.service';

@Component({
  selector: 'app-business-group',
  templateUrl: './business-group.component.html',
  styleUrls: ['./business-group.component.scss']
})
export class BusinessGroupComponent implements OnInit {

  selectedtype = [];
  agent_code: any = null;
  booth_code: any = null;
  business_details: any = null;
  business_available = false;
  payment_modes: Object;
  selected_payment_mode = 2
  add_money_form: FormGroup;
  amount: any;
  selectamount: any;
  agent_id: any;
  min_date: string;
  transaction_history: Object;
  title: any;
  selectbusinesstype: any = [];
  selectbusinessgroup: any;
  selectbusinessgroups: any;
  Transaction_Id: any;
  business_group_id: any;
  business_type_id: any;
  transaction_id: any;
  deposit_amount: any;
  date: any;
  business_types: any = [];
  business_name: any = [];
  selectedOption: any;
  route_disabled = true;
  all_id_list = [];
  showBusinessGroupDropdown: boolean = true;
  showBusinessNamedropdown: boolean = true;
  businessGroup: string;
  selectbusinessname: any;
  Buisness_Name: boolean = false;
  Business_Group_Name: boolean = false
  business_code: any;
  businessCodes: any;
  business_codes: any;


  constructor(private global: GlobalService, private http: HttpService, private formBuilder: FormBuilder,) {
    // this.global.set_master_page_title = 'Add To Wallet';
    this.title = this.global._active_display_name;
    this.getUserBasedBusinesstype()
    this.getbusinesstype();
    this.getbusinessname()

    let today = new Date();
    this.min_date = new Date(today).toISOString().split('T')[0];
    this.http.getPaymentModes().subscribe((data) => {
      console.log(data);
      this.payment_modes = data;

    })
    this.add_money_form = this.formBuilder.group({
      bank_name: [null, Validators.compose([Validators.required])],
      branch_name: [null, Validators.compose([Validators.required])],
      ifsc_code: [null, Validators.compose([Validators.required])],
      micr_code: [null],
      account_holder_name: [null, Validators.compose([Validators.required])],
      account_number: [null, Validators.compose([Validators.required])],
      cheque_issue_date: [null, Validators.compose([Validators.required])],
      cheque_number: [null, Validators.compose([Validators.required])],
    })
  }

  ngOnInit() {

  }

  // changebusinesstype = (event) => { };


  getUserBasedBusinesstype() {
    this.http.getbusinesstype().subscribe((data) => {
      console.log(data);
      this.selectbusinesstype = data;

    })
  }

  // checkBoothExists() {
  //   let data_dict = {
  //     'business_group_id': 1,
  //     'business_type_id': 4,
  //     // 'transaction_id': this.transaction_id,
  //     // 'deposit_amount': this.deposit_amount,
  //   };
  //   console.log(data_dict);
  //   this.http.businessgrouppaymentreceived(data_dict).subscribe((data) => {
  //     console.log(data);
  //   });
  // }
  // checkBoothExists() {
  //   let data_dict = {

  //     'transaction_id': this.,
  //     'deposit_amount': this.deposit_amount,
  //   };
  //   console.log(data_dict);
  //   this.http.businessgrouppaymentreceived(data_dict).subscribe((data) => {
  //     console.log(data);
  //     if (data['found']) {
  //       this.business_details = data;
  //       this.business_available = true;
  //       // this.agent_id = data['agent_id']
  //       let data_dict = {
  //         'business_group_id': this.business_group_id,
  //         'business_type_id': this.business_type_id,
  //       }
  //       this.http.serveTransactionHistoryAgent(data_dict).subscribe((his_data) => {
  //         console.log(his_data)
  //         this.transaction_history = his_data
  //       })
  //     } else {
  //       this.business_group_id = null;
  //       this.business_type_id = null;
  //       this.business_details = null;
  //       this.business_available = false;
  //       // alert('Agent not available');
  //     }
  //   }, (error) => {
  //     this.booth_code = null;
  //     this.agent_code = null;
  //     this.business_details = null;
  //     this.business_available = false;
  //     console.error(error);
  //   });
  // }



  checkBoothExists() {
    let data_dict = {
      'business_type_id': this.selectbusinesstype,
    };

    if (this.showBusinessGroupDropdown) {
      data_dict['business_group_id'] = 1;
      data_dict['business_code'] = 3033;
    }
    if (this.showBusinessNamedropdown) {
      data_dict['business_code'] = this.selectbusinessgroup;
    }
    else {
      data_dict['business_group_id'] = 1;
    }
    console.log(data_dict)
    this.http.receivedDepositAmount(data_dict).subscribe((data) => {
      this.business_details = data;
      this.business_available = true;
    });
  }

  getbusinesstype() {
    this.http.getBusinessType().subscribe((data) => {
      console.info(data);
      this.business_types = data['business_type'];
      console.info(this.business_types)
    });
  }

  onbusinessselecttype() {
    console.info(this.selectbusinesstype);
    this.getbusinessname();
    this.getbusinesstype();
  }
  onbusinessselectgroup() {
    this.showBusinessNamedropdown = false;
    this.Business_Group_Name = true;
  }

  onbusinessselectname() {
    this.showBusinessGroupDropdown = false;
    this.Buisness_Name = true;
    console.info(this.selectbusinessgroup)
  }

  getbusinessname() {
    let data_dict = {
      'business_type_id': this.selectbusinesstype,
    }
    console.info(data_dict);
    this.http.servebusinessname(data_dict).subscribe((data) => {
      console.log(data);
      this.business_name = data;
      console.info(this.business_name);

      this.business_codes = data['business_types']
      this.businessCodes = this.business_codes.map((businessType) => businessType.business_code);
      console.info(this.businessCodes);

      this.business_name['business_types'].forEach(element => {
        this.all_id_list.push(element.id)
      });
      this.selectedOption = this.all_id_list

    }, (error) => {
      console.log(error);
    })

  }
  checkboxChanged(event) {
    if (event.checked) {
      this.selectedOption = this.all_id_list;
      this.route_disabled = true;
    } else {
      this.selectedOption = [];
      this.route_disabled = false;
    }
  }
  addMoney() {
    // this.amount = parseInt(this.amount)
    if (this.selectamount <= 0 || this.selectamount == null || this.selectamount == '') {
      alert('please enter a valid amount');
      this.selectamount = null;
      return false;
    }
    console.log(this.add_money_form.value)
    const data_dict = {
      'deposit_amount': this.selectamount,
      'transaction_id': this.Transaction_Id,
      'business_type_id': this.selectbusinesstype,
      'date': this.date,
    }
    if (this.showBusinessGroupDropdown) {
      data_dict['business_group_id'] = 1;
      data_dict['business_code'] = 3033;
    }
    if (this.showBusinessNamedropdown) {
      data_dict['business_code'] = this.selectbusinessgroup;
    }
    else {
      data_dict['business_group_id'] = 1;
    }

    if (this.selected_payment_mode == 3) {
      data_dict['cheque_details'] = this.add_money_form.value
    }

    // if (this.selected_payment_mode == 1) {
    //   data_dict['transaction_details'] = this.add_money_form.value
    // }
    this.http.businessgrouppaymentreceived(data_dict).subscribe((data) => {
      console.log(data);
      this.global.showSnakeBar('money added to wallet')
      // this.business_available = false;
      this.selected_payment_mode = 2
      this.amount = null;
      // this.agent_code = null;
      // this.booth_code = null;
      this.checkBoothExists()
    }, (error) => {
      console.log(error);
    })
  }

  clearBankDetails() {
    this.add_money_form.controls['bank_name'].setValue(null);
    this.add_money_form.controls['branch_name'].setValue(null);
    this.add_money_form.controls['ifsc_code'].setValue(null);
    this.add_money_form.controls['micr_code'].setValue(null);
    this.add_money_form.controls['account_holder_name'].setValue(null);
    this.add_money_form.controls['account_number'].setValue(null);
    this.add_money_form.controls['cheque_issue_date'].setValue(null);
    this.add_money_form.controls['cheque_number'].setValue(null);

  }

  changePayment() {
    console.log(this.selected_payment_mode);
    if (this.selected_payment_mode == 3) {
      this.add_money_form.controls['bank_name'].setValue(this.business_details['bank_name']);
      this.add_money_form.controls['branch_name'].setValue(this.business_details['branch_name']);
      this.add_money_form.controls['ifsc_code'].setValue(this.business_details['ifsc_code']);
      this.add_money_form.controls['micr_code'].setValue(this.business_details['micr_code']);
      this.add_money_form.controls['account_holder_name'].setValue(this.business_details['account_holder_name']);
      this.add_money_form.controls['account_number'].setValue(this.business_details['account_number']);
      this.add_money_form.controls['cheque_issue_date'].setValue(null);
      this.add_money_form.controls['cheque_number'].setValue(null);
    }
  }
}
